<div class="modal-content funding">
    <div class="modal-header border-0">
        <h3 class="modal-title" id="modulesModalLabel"></h3>
        <button type="button" class="btn-close" (click)="modalFunding.dismissAll()"></button>
    </div>
    <div class="modal-body p-4">
        <div class="row tread-cards justify-content-center">
<!--                    <div class="col-xl-6 col-sm-6 mx-auto">-->
<!--                        <div class="card widget-1">-->
<!--                            <div class="card-body common-box">-->
<!--                                <div class="widget-icon primary widget-round">-->
<!--                                    <app-common-svg-icons icons="payment"></app-common-svg-icons>-->
<!--                                </div>-->
<!--                                <div>-->
<!--                                    <h4 class="f-w-600">Por fondear</h4>-->
<!--                                    <span class="f-w-500 f-light f-12">{{ '0' | currency}}</span>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->

            <div class="col-xl-6 col-sm-6 mx-auto">
                <div class="card widget-1">
                    <div class="card-body common-box">
                        <div class="widget-icon success widget-round">
                            <app-common-svg-icons icons="bill"></app-common-svg-icons>
                        </div>
                        <div>
                            <h4 class="f-w-600">Fondeado</h4>
                            <span class="f-w-500 f-light f-12">{{ totalFunding | currency}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        @if (!openNew){
            <div class="card-header card-no-border">
                <div class="header-top order-lists">
                    <div>
                        <h4>Lista de fondeos<span class="d-block f-w-500 f-light f-12">{{listFunding.length}} registro(s)</span></h4>
                    </div>
                    <div class="card-header-right-icon">
                        <button class="btn btn-primary" type="button" (click)="openNew = true; isNewRecord = true;">Nuevo</button>
                    </div>
                </div>
            </div>

            <div class="card-body transaction-list recent-orders list-funding">
                <ul class="order-list mb-0">
                    @for (item of listFunding; track item) {
                        <li>
                            <div class="light-card" (click)="getEvidenceFiles(item)">
                                <img [src]="(item.evidence_urls?.split(',')[0]) || 'assets/img/service/no-image.png'" alt="img"></div>
                            <div class="order-content">
                                <div>
                                    <h6 class="mb-1">{{item.created_at}}</h6>
                                    <span><span class="badge badge-light-primary">#{{item.id}}</span><span class="f-light f-w-500 f-12 ms-2">{{item.comments}}</span></span>
                                </div>
                                <div class="text-end">
                                    <div class="dropdown icon-dropdown">
                                        <button class="btn dropdown-toggle" id="order-1" type="button" (click)="item.isShow =!item.isShow">
                                            <app-common-svg-icons [icons]="'more-horizontal'"></app-common-svg-icons>
                                        </button>
                                        <div class="dropdown-menu dropdown-menu-end" [class.show]="item.isShow"
                                             style="position: absolute; inset: 0px 0px auto auto; margin: 0px; transform: translate(0px, 31px);">
                                            <a class="dropdown-item" (click)="edit(item)">Editar</a>
                                            <a class="dropdown-item" (click)="delete(item)">Eliminar</a>
                                        </div>
                                    </div><span class="f-light f-w-500 f-12">${{item.amount}} {{item.currency}}</span>
                                </div>
                            </div>
                        </li>
                    }
                    @if (listFunding.length == 0){

                        <li class="row text-center mt-3">
                            <div>
                                <h6 class="mb-1">Sin registros</h6>
                            </div>
                        </li>
                    }
                </ul>
            </div>
        } @else {

            <div class="card-body transaction-list recent-orders">
                <div class="card-header card-no-border">
                    <div class="header-top mt-2">
                        <h4>{{(isNewRecord) ? 'Nuevo fondeo' : 'Editar fondeo'}}</h4>
                    </div>
                </div>

                <form [formGroup]="fundingForm" class="mt-4">
                    <div class="row">

                        <!-- Amount -->
                        <div class="col-md-6 mb-3">
                            <label class="form-check-label ms-2">
                                Monto *
                            </label>
                            <input type="number" class="form-control"
                                   [class.is-invalid]="fundingForm.get('amount')?.touched && fundingForm.get('amount')?.invalid"
                                   formControlName="amount" placeholder="">

                            <div *ngIf="fundingForm.get('amount')?.touched && fundingForm.get('amount')?.invalid" class="invalid-feedback">
                                Ingrese un valor válido.
                            </div>
                        </div>

                        <!-- Comentario -->
                        <div class="col-md-6 mb-3">
                            <label class="form-check-label ms-2">
                                Comentario *
                            </label>
                            <textarea
                                    class="form-control"
                                    rows="1"
                                    required="true"
                                    formControlName="comment"
                                    maxlength="255"
                                    [class.is-invalid]="fundingForm.get('comment')?.touched && fundingForm.get('comment')?.invalid"
                            ></textarea>
                            <div *ngIf="fundingForm.get('comment')?.touched && fundingForm.get('comment')?.invalid" class="invalid-feedback">
                                Ingrese un valor válido.
                            </div>
                        </div>

                        @if(listEvent.length != 0){
                            <!-- Evento -->
                            <div class="col-md-6 mb-3">
                                <label class="form-check-label ms-2">
                                    Evento
                                </label>
                                <select class="form-select" formControlName="event">
                                    <option [ngValue]="null" disabled selected>Seleccione un evento</option>
                                    <option *ngFor="let item of listEvent" [value]="item.id">{{ item.value }}</option>
                                </select>
                            </div>
                        }

                        <div class="col-md-12 mb-3">
                            <div class="mb-3">
                                <label>Evidencias</label>
                                <form class="dropzone dropzone-light custom-scrollbar customize-dropzone">
                                    <dropzone [config]="config" [message]="textDropzone" (init)="onDropzoneInit($event)" (error)="onUploadError($event)" (success)="onUploadSuccess($event)" (removedFile)="onRemoveSuccess($event)">
                                    </dropzone>
                                </form>
                            </div>
                        </div>

                    </div>
                </form>

            </div>
        }

    </div>
    <div class="modal-footer" *ngIf="openNew">
        <!-- Botones form-->
        <div class="d-flex justify-content-end gap-2 mt-2">
            <button type="button" class="btn btn-secondary col-auto" (click)="cancelForm()">Cancelar</button>
            <button type="button" class="btn btn-primary col-auto" (click)="submitForm()">Agregar</button>
        </div>
    </div>
</div>
